/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = $window.innerWidth;
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	var scrollPosition = void 0;
	
	var _isSP = void 0;
	var windowWi = window.innerWidth;
	var prewidth = window.innerWidth;
	
	var $wrapper = $('#index-Keyvisual');
	var wrapperHeight = $wrapper.height();
	
	var _isAurora = true;
	
	// tmppath
	var tmppath = $('#st-Container').attr('data-tmpdir');
	
	//preload
	
	(0, _module.preload)();
	
	//showMovie
	
	(0, _module.showMovie)();
	
	//toggleHeader
	
	(0, _module.toggleHeader)();
	
	// anchorLink
	
	(0, _module.anchorLink)();
	
	// commentModal
	
	(0, _module.commentModal)();
	
	// kvModal
	
	(0, _module.kvModal)();
	
	//divideCharacter
	
	(0, _module.divideCharacter)();
	
	//showPopup
	// import {showPopup} from "../include/module";
	// showPopup();
	
	
	$(window).on('resize load', function () {
	  if (windowWi <= 1024) {
	    _isSP = true;
	  } else {
	    _isSP = false;
	  };
	
	  //リサイズ処理 ブレイクポイントを跨いだらリロード
	  var nowWidth = window.innerWidth;
	  if (prewidth !== nowWidth) {
	    if (prewidth < 1025) {
	      if (nowWidth >= 1025) {
	        location.reload();
	      }
	    } else {
	      if (nowWidth < 1025) {
	        location.reload();
	      }
	    }
	  };
	});
	
	$(window).on('load', function () {
	
	  //春
	  if (_isSP) {
	    showerSakuraSP();
	  } else {
	    showerSakura();
	  };
	
	  // visualRandom();
	
	  //夏
	  // summer('summer');
	
	  //秋
	  // fallAnimation();
	
	  // 冬
	  // snowFall();
	
	  showKV();
	  scrollIndexAnime();
	  isMobile();
	
	  setTimeout(function () {
	    var $widget = $('iframe.twitter-timeline');
	    var $widgetContents = $widget.contents();
	    $widgetContents.find('.timeline-Body').css({ "border-top": "none", "border-bottom": "none" });
	  }, 1000);
	
	  floatingbanner();
	});
	
	// ------------------------------------------------------------------------
	// fallAnimation
	// ----- BOTH
	// ------------------------------------------------------------------------
	// const fallAnimation = () => {
	//
	//   const $canvas = $('#fall-canvas');
	//   let count = 0;
	//
	//   let canvasWidth = $canvas.innerWidth();
	//   let canvasHeight = $canvas.innerHeight();
	//
	//   // アプリケーションの作成
	//   const app = new PIXI.Application(canvasWidth, canvasHeight, {transparent : true});
	//   $canvas.append(app.view);
	//
	//   // コンテナの作成
	//   let container = new PIXI.Container();
	//   // ステージに反映
	//   app.stage.addChild(container);
	//   container.x = 0;
	//   container.y = 0;
	//
	//   // 表示をするパーティクルの数
	//   let totalParticle;
	//   if(!_isSP) {
	//     totalParticle = 8;
	//   } else {
	//     totalParticle = 8;
	//   }
	//
	//   //　画像配列
	//   let images = [
	//     tmppath + 'assets/images/common/index/img_leaf-0.png',
	//     tmppath + 'assets/images/common/index/img_leaf-1.png',
	//     tmppath + 'assets/images/common/index/img_leaf-2.png',
	//     tmppath + 'assets/images/common/index/img_leaf-3.png',
	//     tmppath + 'assets/images/common/index/img_leaf-4.png',
	//   ]
	//
	// // パーティクル用の配列
	// const particles = [];
	//
	// // totalParticle回数分ループ
	// for (let i = 0; i < totalParticle; i++) {
	//
	//   // パーティクルの画像設定
	//   let n = Math.floor(Math.random() * images.length);
	//   const particle = PIXI.Sprite.from(images[n]);
	//
	//   // パーティクルの中心をきめる
	//   particle.anchor.set(0.5);
	//
	//   // サイズをランダムにきめる
	//   var minS = .19;
	//   var maxS = .2;
	//
	//   if(!_isSP) {
	//     minS = .85;
	//     maxS = .9;
	//   } else {
	//     minS = .215;
	//     maxS = .218;
	//   }
	//   const size = ((Math.random() * (maxS + 1 - minS)) + minS) * .05;
	//   particle.scale.set(size);
	//
	//   // 横の表示位置
	//   var minX = 0;
	//   var maxX = 1;
	//
	//   //  速度
	//   var minY = .6;
	//   var maxY = .8;
	//
	//   // パーティクルの位置
	//   particle.x = Math.random() * app.screen.width;
	//   particle.y = Math.random() * app.screen.height;
	//
	//   // 速度と向き
	//   particle.vx = app.screen.width * 0.001 * (Math.random() - 0.5); // 0~1 - .5 = -.5 ~ .5;
	//   particle.vy = app.screen.height * 0.001 * ((Math.random() * (maxY + 1 - minY)) + minY);
	//
	//   particle.rotation = Math.random() * 360;
	//   particle.pivotX = Math.random() * 360;
	//
	//   // 生成されたパーティクルの配列をpushして簡単にアクセスできるようにします
	//   particles.push(particle);
	//
	//   // コンテナに反映
	//   container.addChild(particle);
	//
	// }
	//
	// // アニメーションフレーム毎の処理を指定
	// app.ticker.add(function() {
	//   count += 0.1;
	//
	//   // 画像を繰り返し処理して位置を更新する
	//   for (let i = 0; i < particles.length; i++) {
	//     //配列を代入
	//     const particle = particles[i];
	//
	//     // 回転
	//     particle.rotation += Math.random() * 0.02;
	//
	//     // 摩擦
	//     particle.vx *= .996;
	//     particle.vy *= 1;
	//
	//     // 縦の位置を更新
	//     particle.x += particle.vx;
	//     particle.y += particle.vy;
	//
	//
	//      // 画面の一番下に行った時縦の位置をリセット、横の位置をランダムに配置
	//     if (particle.y  > canvasHeight + particle.height) {
	//       particle.y = -particle.height;
	//       particle.x = Math.random() * app.screen.width;
	//       particle.vx = app.screen.width * 0.005 * (Math.random() - 0.5); // 0~1 - .5 = -.5 ~ .5;
	//       particle.vy = app.screen.height * 0.001 * ((Math.random() * (maxY + 1 - minY)) + minY);
	//     }
	//   }
	// });
	//
	// //現在のウィンドウ幅
	// var prewidth = $(window).width()
	//
	// //リサイズ処理 ブレイクポイントを跨いだらリロード
	// $(window).on("load resize", function () {
	//
	//   // app.renderer.resize(elmWidth,elmHeight);
	//   var nowWidth = $(window).width()
	//   if(prewidth !== nowWidth){
	//     if(prewidth < 1025) {
	//       if(nowWidth >= 1025){
	//         location.reload();
	//       }
	//     }else {
	//       if(nowWidth < 1025){
	//         location.reload();
	//       }
	//     }
	//   };
	// });
	//
	// }
	
	/*******************************************************
	
	snowFall（冬）
	
	********************************************************/
	
	var snowFall = function snowFall() {
	  // 雪を降らせる
	  particlesJS("snow-canvas", {
	    "particles": {
	      //シェイプの設定
	      "number": {
	        "value": 150, //シェイプの数
	        "density": {
	          "enable": true, //シェイプの密集度の設定許可
	          "value_area": 800 //シェイプの密集度
	        }
	      },
	      "shape": {
	        "type": "image", //circle、edge、triangle、polygon、star、image から選べる
	        "image": {
	          "src": "/wp-content/themes/watakon_v0/assets/images/common/index/img_snow.png" //雪の画像を設定する ※相対パスでも可
	        }
	      },
	      "opacity": {
	        "value": 0.7, //透明度
	        "random": false, //透明度ランダムの許可
	        "anim": {
	          "enable": false, //透明度のアニメーションさせるかどうか
	          "speed": 1, //アニメーションのスピード
	          "opacity_min": 0.1, //透明度の最小値
	          "sync": false //シェイプを同時にアニメーションさせるかどうか
	        }
	      },
	      "size": {
	        "value": 5, //シェイプの大きさ
	        "random": true, //大きさランダムの許可
	        "anim": {
	          "enable": false, //大きさアニメーションさせるかどうか
	          "speed": 20, //スピード
	          "size_min": 0.1, //スピードの最小値
	          "sync": false //同時にアニメーションさせるかどうか
	        }
	      },
	      // 線の設定
	      "line_linked": {
	        "enable": false //線を表示するかどうか
	      },
	      // 動きの設定
	      "move": {
	        "enable": true, //シェイプの動かすかどうか
	        "speed": 2, //スピード
	        "direction": "bottom", //シェイプの動く方向(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-left から選べる)
	        "random": true, // 動きはランダム
	        "straight": false, // 動きをとどめない
	        "out_mode": "out", //エリア外に出たシェイプの動き(out、bounce から選べる)
	        "bounce": false, //跳ね返りなし
	        "attract": {
	          "enable": true,
	          "rotateX": 300,
	          "rotateY": 1200
	        }
	      }
	    },
	    "interactivity": {
	      "detect_on": "canvas",
	      "events": {
	        //マウスオーバー時
	        "onhover": {
	          "enable": false //マウスオーバーの許可
	        },
	        //クリック時
	        "onclick": {
	          "enable": false
	        },
	        "resize": true
	      }
	    },
	    "retina_detect": true
	  });
	};
	
	/*******************************************************
	
	isMobile
	
	********************************************************/
	function isMobile() {
	  windowWidth = $window.width();
	  if (windowWidth >= 1025) {
	    _isSP = false;
	  } else {
	    _isSP = true;
	  }
	};
	
	// /*******************************************************
	
	// summer
	
	// ********************************************************/
	// const summer = (target) => {
	//   var windowWidth;
	//   var elm   = document.getElementById(target);
	//   var elmWidth = elm.clientWidth;
	//   var elmHeight = elm.clientHeight;
	//   var app = new PIXI.Application({
	//     width : elmWidth,
	//     height : elmHeight,
	//     // resizeTo: window
	//   });
	//   //Pixi用のcanvasタグを追加
	//   elm.appendChild(app.view);
	
	//   var bg;
	//   if(!_isSP) {
	//     bg = PIXI.Sprite.fromImage(tmppath + "./assets/images/pc/index/img_kv-1.jpg");
	//   } else {
	//     bg = PIXI.Sprite.fromImage(tmppath + "./assets/images/sp/index/img_kv-1.jpg");
	//   }
	//   bg.x = 0;
	//   bg.y = 0;
	//   if(!_isSP) {
	//     windowWidth = $(window).width();
	//     // if(windowWidth >= 1200){
	//       bg.width = app.renderer.width;
	//       bg.height = app.renderer.width * .6864583;
	//     // }else{
	//     //   bg.width = 1200;
	//     //   bg.height = 1200 * .6864583;
	//     // }
	//   } else {
	//     bg.width = app.renderer.width;
	//     bg.height = app.renderer.width * 1.9140625;
	//   }
	
	//   app
	//   .loader
	//   .load((loader,resources) => {
	
	//     let godrayFilter = new PIXI.filters.GodrayFilter({
	//       time: 0,
	//       parallel: false,
	//       lacunarity: 2.75,
	//       gain: .55,
	//       angle: -10,
	//       // center: [elmWidth, -elmHeight / 1],
	//       center: [0,  -elmHeight / 2.5],
	//     });
	
	//     if(!_isSP) {
	//       godrayFilter = new PIXI.filters.GodrayFilter({
	//         time: 0,
	//         parallel: true,
	//         lacunarity: 2.2,
	//         gain: .5,
	//         angle: -25,
	//         alpha: 0,
	//       });
	//     }
	
	
	//     app.stage.addChild(bg).filters = [godrayFilter];
	
	//     //フィルターをアニメーションさせる
	//     TweenMax.to(godrayFilter, 6, {
	//       time: 1,
	//       ease: Linear.easeNone,
	//       repeat: -1,
	//       yoyo: true
	//     });
	
	//   });
	
	//   var prewidth = $(window).width()
	
	//   //リサイズ処理 ブレイクポイントを跨いだらリロード
	//   $(window).on("load resize", function () {
	//     isMobile();
	
	//     app.renderer.resize(elm.clientWidth, elm.clientHeight);
	//     var nowWidth = $(window).width()
	//     if(prewidth !== nowWidth){
	//       if(prewidth < 768) {
	//         if(nowWidth >= 768){
	//           location.reload();
	//         }
	//       }else {
	//         if(nowWidth < 768){
	//           location.reload();
	//         }
	//       }
	//     };
	
	//     if(!_isSP) {
	//       windowWidth = $window.width();
	//       // if(windowWidth >= 1200){
	//         bg.width = app.renderer.width;
	//          bg.height = app.renderer.width * .6864583;
	//       // }else{
	//       //   bg.width = 1200;
	//       //   bg.height = 1200 * .6864583;
	//       // }
	//     } else {
	//       bg.width = app.renderer.width;
	//       bg.height = app.renderer.width * 1.9140625;
	//     }
	//   });
	
	//   //キービジュアル見えなくなったら幅0にする
	//   $(window).on("scroll", function () {
	//     if(_isAurora) {
	//       if(scrollPosition > wrapperHeight){
	//         bg.width = 0;
	//         _isAurora = false;
	//       }
	//     } else {
	//       if(scrollPosition > wrapperHeight){
	//       } else {
	//         if(!_isSP) {
	//           _isAurora = true;
	//           windowWidth = $window.width();
	//           // if(windowWidth >= 1200){
	//             bg.width = app.renderer.width;
	//           // }else{
	//           //   bg.width = 1200;
	//           // }
	//         } else {
	//           bg.width = app.renderer.width;
	//         }
	//       }
	//     }
	//   });
	
	// };
	
	
	// ------------------------------------------------------------------------
	// showerSakura
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showerSakura = function showerSakura() {
	  $('#index_Sakura').sakura('start', {
	    fallSpeed: 1.5,
	    newOn: 700,
	    maxSize: 26,
	    minSize: 8
	  });
	};
	
	// ------------------------------------------------------------------------
	// showerSakuraSP
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showerSakuraSP = function showerSakuraSP() {
	  $('#index_Sakura').sakura('start', {
	    fallSpeed: 1.5,
	    newOn: 1300,
	    maxSize: 20,
	    minSize: 8
	  });
	};
	
	// ------------------------------------------------------------------------
	// visualRandom
	// ----- BOTH
	// ------------------------------------------------------------------------
	var visualRandom = function visualRandom() {
	
	  var target = document.getElementById('randamKV');
	  var data = {
	    'index-Keyvisual_Img-0-kimono': 10 // 10%
	    // 通常 90%
	  };
	  var rand = Math.floor(Math.random() * 100);
	  var result = 'index-Keyvisual_Img-0';
	  var rate = 0;
	  for (var prop in data) {
	    rate += data[prop];
	    if (rand <= rate) {
	      result = prop;
	      break;
	    }
	  }
	
	  // console.log(result);
	  target.classList.add(result);
	};
	
	// ------------------------------------------------------------------------
	// showKV
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showKV = function showKV() {
	
	  setTimeout(function () {
	    $('#index-Loader').addClass("load");
	  }, 0);
	  setTimeout(function () {
	    $('#index-Loader_Inner').addClass("hidden");
	  }, 0);
	  setTimeout(function () {
	    $('#index-Loader').addClass("hidden");
	  }, 500);
	  setTimeout(function () {
	    $('#index-Loader').remove();
	  }, 2500);
	  setTimeout(function () {
	    $('#index_Sakura').addClass("load");
	  }, 2500);
	};
	
	// ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollIndexAnime = function scrollIndexAnime() {
	
	  var controller = new ScrollMagic.Controller();
	
	  //　スクロールで発火
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .9
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	};
	
	// ------------------------------------------------------------------------
	// closeFloatingbanner
	// ----- BOTH
	// ------------------------------------------------------------------------
	var floatingbanner = function floatingbanner() {
	  var $floatingBanner = $('#floating-banner');
	  var scrollPosition = 0;
	  if (_isSP) {
	    scrollPosition = 100;
	  } else {
	    scrollPosition = 300;
	  }
	  $(window).on("scroll", function () {
	    if ($(this).scrollTop() < scrollPosition) {
	      $floatingBanner.removeClass('is-show');
	    } else {
	      $floatingBanner.addClass('is-show');
	    }
	  });
	  $('#floating-banner .close').on("click", function () {
	    $('#floating-banner').addClass('invisible');
	  });
	};
	
	// ------------------------------------------------------------------------
	// banner-area-swiper
	//
	// ------------------------------------------------------------------------
	
	// PC処理
	if ($('.banner-Item').length >= 3 && window.matchMedia('(min-width: 1025px)').matches) {
	  var bnrSwiper = new Swiper('.bnr_List', {
	    direction: 'horizontal',
	    loop: true,
	    slidesPerView: 3,
	    loopAdditionalSlides: 3,
	    pagination: {
	      el: '.bnr-pagination',
	      clickable: true
	    },
	    navigation: { //ナビゲーションのオプション（矢印ボタンの要素を指定）
	      nextEl: '.bnr-button-next',
	      prevEl: '.bnr-button-prev'
	    }
	  });
	} else {
	  $('.bnr_List_Wrapper').addClass('nonactive');
	  $('.bnr-button-wrapper').addClass('none');
	}
	
	// SP処理
	if ($('.banner-Item').length >= 2 && window.matchMedia('(max-width: 1024px)').matches) {
	  var _bnrSwiper = new Swiper('.bnr_List', {
	    direction: 'horizontal',
	    loop: true,
	    slidesPerView: 1,
	    loopAdditionalSlides: 3,
	    pagination: {
	      el: '.bnr-pagination',
	      clickable: true
	    }
	  });
	}
	
	/*-------------------------------------------------------------------*/
	/* popup_modal */
	/*-------------------------------------------------------------------*/
	var popup_modal = function popup_modal() {
	  $('.popup-modal').on('click', function () {
	    $(this).css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $(this).css({ 'display': 'none' });
	    });
	  });
	  //  $('.popup-modal .popup-modal_Close').on('click', function () {
	  //    $('.popup-modal').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	  //      $('.popup-modal').css({ 'display': 'none' });
	  //    });
	  //  });
	};
	popup_modal();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	
	    $('body').addClass('preload');
	
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	
	  headerButton.addEventListener('click', function () {
	
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#sw-Youtube').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	
	    $('#sw-Youtube').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 50;
	      $('body,html').stop().animate({ scrollTop: position }, 500);
	    }, 200);
	  }
	
	  var __layer = $('.st-Container').attr('data-layer');
	  var linkSpeed = 1800;
	  var linkAdjust = 0;
	
	  //トップページ時ののヘッダーリンク
	  $(".header-link").on("click", function () {
	    if (__layer == 'first') {
	      var linkHref = $(this).attr("href");
	      var linkHash = linkHref.substr(linkHref.indexOf('#'));
	      console.log(linkHash);
	      var linkTarget = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
	      var linkPosition = linkTarget.offset().top;
	
	      if (headerFlag) {
	        stHeaderNav.classList.remove('opened');
	        headerButton.classList.remove('opened');
	        stHeaderBg.classList.remove('opened');
	        stHeaderNav.classList.add('closed');
	        headerButton.classList.add('closed');
	        stHeaderBg.classList.add('closed');
	        headerFlag = false;
	      }
	      $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "easeInOutQuint");
	      return false;
	    }
	  });
	
	  //ページ内リンク
	  $("a[href^='#']").on("click", function () {
	
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	
	  // if( __layer == 'first') {
	  //   console.log('aaa');
	  // }
	
	};
	
	// ------------------------------------------------------------------------
	// commentModal
	// ----- BOTH
	// ------------------------------------------------------------------------
	var commentModal = function commentModal() {
	  var $modal = $('#sw-Comment');
	
	  $('.js-comment').on('click', function () {
	
	    var target = $(this).data('modal-link');
	    modalOpen(target);
	
	    // モーダルのスクロール位置上に
	    scrollComment();
	  });
	
	  $('.sw-Comment_Close').on('click', function () {
	
	    modalClose();
	  });
	
	  // モーダルを開く
	  function modalOpen(target) {
	
	    // モーダルが開いたら、bodyにfixedを付与
	    // bodyFixedOn();
	
	    $('[data-modal-content = ' + target + ']').addClass('is-show');
	    $modal.addClass('opened');
	  }
	
	  // モーダルを閉じる
	  function modalClose() {
	    $('[data-modal-content]').removeClass('is-show');
	    $modal.removeClass('opened');
	
	    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
	    // bodyFixedOff();
	  }
	
	  //モーダルのスクロール一番上へ
	  function scrollComment() {
	
	    $('#sw-Comment,#sw-Comment_Inner').scrollTop(0);
	  }
	};
	
	// ------------------------------------------------------------------------
	// kvModal
	// ----- BOTH
	// ------------------------------------------------------------------------
	var kvModal = function kvModal() {
	  var $modal = $('#modal-KV');
	
	  $('.btn_KV').on('click', function () {
	
	    var target = $(this).data('kv-link');
	    modalOpen(target);
	
	    // console.log(target);
	
	    // モーダルのスクロール位置上に
	    scrollComment();
	  });
	
	  $('.modal-KV_Close').on('click', function () {
	
	    modalClose();
	  });
	
	  // モーダルを開く
	  function modalOpen(target) {
	
	    // モーダルが開いたら、bodyにfixedを付与
	    // bodyFixedOn();
	
	    $('[data-kv-content = ' + target + ']').addClass('is-show');
	    $modal.addClass('opened');
	  }
	
	  // モーダルを閉じる
	  function modalClose() {
	    $('[data-kv-content]').removeClass('is-show');
	    $modal.removeClass('opened');
	
	    // モーダルが閉じられたら、スクロールのトップを取得してbodyに
	    // bodyFixedOff();
	  }
	
	  //モーダルのスクロール一番上へ
	  function scrollComment() {
	
	    $('#modal-KV,#modal-KV_Inner').scrollTop(0);
	  }
	};
	
	// ------------------------------------------------------------------------
	// divideCharacter
	// ----- BOTH
	// ------------------------------------------------------------------------
	var divideCharacter = function divideCharacter() {
	
	  var textbox = document.querySelectorAll('.divide-character');
	  var textboxArray = Array.prototype.slice.call(textbox); //Array
	
	
	  textboxArray.forEach(function (textbox) {
	    var text = textbox.textContent;
	    textbox.innerHTML = null;
	
	    text.split('').forEach(function (c) {
	      textbox.innerHTML += '<span class="letter">' + c + '</span>';
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// showPopup
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showPopup = function showPopup() {
	  // open
	  $('#popup-Image').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + '%', 'top': 0, 'left': 0 }, 500, 'easeOutQuart', function () {
	    return false;
	  });
	
	  //close
	  $('#popup-Bg,#popup-Close').on('click', function () {
	    $('#popup-Image').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#popup-Image').css({ 'display': 'none' });
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// closeFloatingbanner
	// ----- BOTH
	// ------------------------------------------------------------------------
	var closeFloatingbanner = function closeFloatingbanner() {
	  //close
	  $(document).ready(function () {
	    $('.banner-close').click(function () {
	      $('.banner').parent().hide();
	    });
	  });
	  $(window).on('scroll', function () {
	    if ($(this).scrollTop() > 100) {
	      $('#floating-banner').fadeIn(300);
	    }
	  });
	};
	
	exports.preload = preload;
	exports.toggleHeader = toggleHeader;
	exports.showMovie = showMovie;
	exports.anchorLink = anchorLink;
	exports.commentModal = commentModal;
	exports.kvModal = kvModal;
	exports.divideCharacter = divideCharacter;
	exports.showPopup = showPopup;
	exports.closeFloatingbanner = closeFloatingbanner;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js